@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="modal-header">
  <h4 class="modal-title">{{selectedReportName | wordReplace}}</h4>
  <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
</div>
<!-- Modal body -->
<div class="modal-body shared-modalcontain">
  <form [formGroup]="mrktReportForm">
    <div class="row">
      <div class="col-md-12">
        <div [ngSwitch]="selectedReportID">
          <span *ngSwitchCase="ERentalReports.OutstandingBalances" class="d-block w-100">
            <div class="row g-3">
              <div class="col-md-6 col-lg-4">
                <div class="card p-3 h-100">
                  <h6 class="fw-bold mb-3">Display</h6>
                  <div class="d-flex gap-4">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" value="0" name="display" id="allVendors" checked
                      formControlName="DisplayVendorid">
                    <label class="form-check-label" for="allVendors">{{'All Vendors' | wordReplace}}</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" value="1" name="display" id="requestedVendor"
                      formControlName="DisplayVendorid">
                    <label class="form-check-label" for="requestedVendor">{{'Requested Vendor' |
                      wordReplace}}</label>
                  </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-8">
                <div class="card p-3 h-100">
                  <h6 class="fw-bold mb-3">Order By</h6>
                  <div class="row">
                    <div class="col-md-6 col-lg-4">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" value="2" name="orderBy" id="vendorId" checked
                          formControlName="OrderBy">
                        <label class="form-check-label" for="vendorId" value="1">{{'Vendor ID' | wordReplace}}</label>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" value="1" name="orderBy" id="vendorName"
                          formControlName="OrderBy">
                        <label class="form-check-label" for="vendorName">{{ 'Vendor Name' | wordReplace
                          }}</label>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" value="3" name="orderBy" formControlName="OrderBy"
                          id="balanceDue" value="3" name="orderBy" formControlName="OrderBy">
                        <label class="form-check-label" for="balanceDue">Balance Due</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="card p-3 h-100">
                  <h6 class="fw-bold mb-3">Display Report</h6>
                  <div class="d-flex gap-4">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" value=2 name="report" formControlName="ReportType"
                      id="detailed">
                    <label class="form-check-label" for="detailed">Detailed</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" value=1 name="report" formControlName="ReportType"
                      id="summary">
                    <label class="form-check-label" for="summary">Summary</label>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3 align-items-center" *ngIf="mrktReportForm.controls['DisplayVendorid'].value === '1'">
              <div class="col-auto">
                <label>{{'Vendor Id' | wordReplace}}</label>
              </div>
              <div class="col col-lg-2">
                <input type="text" class="form-control" id="dealerId" formControlName="marketVendorId"
                  (blur)="getVendorById()" />
              </div>
              <div class="col col-lg-3">
                <input type="text" class="form-control" formControlName="vendorName" disabled />
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-dark" (click)="OpenVendorSearch(vendorSearchModal)">
                  <img src="./assets/images/search.svg" class="img-fluid" />
                </button>
              </div>
            </div>

          </span>
          <span *ngSwitchCase="ERentalReports.BoothPriceListing" class="d-block w-100">
            <div class="row" *ngIf="!noLayout">
              <div class="col-md-12 text-start">
                <div class="card p-3">
                  <h6 class="fw-bold mb-3">{{'Booth Type' | wordReplace}}</h6>
                  <div class="row">
                    <div class="col-lg-8">
                      <div class="row mb-2 align-items-center">
                        <div class="col-auto">
                          <label>
                            <input type="radio" value="0" class="form-check-input" formControlName="BoothType">
                            &nbsp;Show All
                          </label>
                        </div>
                        <div class="col-auto">
                          <label>
                            <input type="radio" value="1" class="form-check-input" formControlName="BoothType">
                            &nbsp;Show Requested
                          </label>
                        </div>
                        <div class="col" *ngIf='mrktReportForm.controls["BoothType"].value == "1"'>
                          <ejs-combobox id="BoothTypeId" formControlName="BoothTypeId" [dataSource]="BoothType"
                            [fields]="{ text: 'BoothType', value: 'BoothType' }" placeholder="Select Booth Type"
                            allowFiltering="true" popupHeight="250px">
                          </ejs-combobox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12 text-start">
                <div class="card p-3">
                  <h6 class="fw-bold mb-3">Charges</h6>
                  <div class="row">
                    <div class="col-lg-8">
                      <div class="row mb-2 align-items-center">
                        <div class="col-auto">
                          <label>
                            <input type="radio" value="0" class="form-check-input" formControlName="BoothCharges">
                            &nbsp;Show All 12 Months
                          </label>
                        </div>
                        <div class="col-auto">
                          <label>
                            <input type="radio" value="1" class="form-check-input" formControlName="BoothCharges">
                            &nbsp;Show Requested Month
                          </label>
                        </div>
                        <div class="col" *ngIf='mrktReportForm.controls["BoothCharges"].value == "1"'>
                          <select class="form-control" formControlName="RequestedMonth">
                            <option *ngFor="let item of months" [value]="item.Id">
                              {{ item.Month }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12 text-start">
                <div class="row g-3">
                  <div class="col-md-6 col-lg-2">
                    <div class="card p-3 h-100">
                      <h6 class="fw-bold mb-3">Display</h6>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="1" formControlName="Display"
                          id="displayBooth">
                        <label class="form-check-label" for="displayBooth">
                          {{'Booth Number' | wordReplace}}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-5">
                    <div class="card p-3 h-100">
                      <h6 class="fw-bold mb-3">Exclude</h6>
                      <div class="row">
                        <div class="col-auto">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="1" id="excludeDesc"
                              formControlName="ExcludeDesc">
                            <label class="form-check-label" for="excludeDesc">
                              {{'Booth Description' | wordReplace}}
                            </label>
                          </div>
                        </div>
                        <div class="col-auto">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="1" id="excludeCat"
                              formControlName="ExcludeCat">
                            <label class="form-check-label" for="excludeCat">
                              Category
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-5" *ngIf="!noLayout">
                    <div class="card p-3 h-100">
                      <h6 class="fw-bold mb-3">Order By</h6>
                      <div class="row">
                        <div class="col-auto">
                          <div class="form-check">
                            <input class="form-check-input" type="radio" name="orderBy" value="1" id="orderType"
                              formControlName="OrderBy">
                            <label class="form-check-label" for="orderType">
                              {{'Booth Type' | wordReplace}}
                            </label>
                          </div>
                        </div>
                        <div class="col-auto">
                          <div class="form-check">
                            <input class="form-check-input" type="radio" name="orderBy" value="2" id="orderNumber"
                              formControlName="OrderBy">
                            <label class="form-check-label" for="orderNumber">
                              {{'Booth number' | wordReplace}}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12 text-start">
                <div class="card p-3">
                  <h6 class="fw-bold mb-3">Rental Types</h6>
                  <div class="row">
                    <div class="col-auto">
                      <div class="form-check" [ngClass]="{'disabled-div': !daily}">
                        <input class="form-check-input" type="radio" value="1" name="RentalType"
                          formControlName="RentalType" id="rdDaily" [attr.disabled]="!daily ? true : null">
                        <label class="form-check-label" for="rdDaily">
                          Daily
                        </label>
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="form-check" [ngClass]="{'disabled-div': !combinedWeekly}">
                        <input class="form-check-input" type="radio" value="5" name="RentalType"
                          formControlName="RentalType" id="rdWeekly" [attr.disabled]="!combinedWeekly ? true : null">
                        <label class="form-check-label" for="rdWeekly">
                          Weekly
                        </label>
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="form-check" [ngClass]="{'disabled-div': !combinedMonthly}">
                        <input class="form-check-input" type="radio" value="4" name="RentalType"
                          formControlName="RentalType" id="rdMonthly" [attr.disabled]="!combinedMonthly ? true : null">
                        <label class="form-check-label" for="rdMonthly">
                          Monthly
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.AvailableBooths" class="d-block w-100">
            <div class="card shadow-sm">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8 col-lg-5 col-xl-4 text-start">
                    <label for="dateInput" class="form-label fw-semibold text-secondary small">Date</label>
                    <ejs-datepicker #RentalDate format='MM/dd/yyyy' [allowEdit]=false formControlName="RentalDate"
                      (renderDayCell)="onRenderDayCell($event)" class="form-control p-0"
                      style="width: 97.5%;"></ejs-datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="card shadow-sm mt-2">
              <div class="card-body">
                <h6 class="fw-bold mb-3">Display</h6>
                <div class="row">
                  <div class="col-md-6 col-lg-4 text-start">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="display" id="rdAvailableBooths"
                        formControlName="All" value="0">
                      <label class="form-check-label" for="rdAvailableBooths">{{'All Available Booths' |
                        wordReplace}}</label>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 text-start">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="display" id="rdRequestedParts"
                        formControlName="All" value="1">
                      <label class="form-check-label" for="rdRequestedParts">Requested Parts</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card shadow-sm mt-2" *ngIf="mrktReportForm.controls['All'].value === '1'">
              <div class="card-body">
                <h6 class="fw-bold mb-3">Parts</h6>
                <div class="form-check">
                  <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-2">
                      <ejs-grid #partGrid [dataSource]='parts' class="Table_Height_store table-striped table-ipad"
                        height='140' [allowFiltering]='false' allowSorting='false' (dataBound)='partsdataBound($event)'
                        allowSelection="false" selectionSettings="{checkboxMode : 'ResetOnRowClick'}">
                        <e-columns>
                          <e-column type="checkbox" headerText='' textAlign='left' width=30>
                            <ng-template #headerTemplate>
                            </ng-template>
                          </e-column>
                          <e-column field='PartDescription' headerText='Part' textAlign='left' width=120>

                          </e-column>
                        </e-columns>
                      </ejs-grid>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.DealerBooths" class="d-block w-100">
            <div class="card p-3">
              <label for="rentalDate" class="form-label">Rental Date</label>
              <div class="row">
                <div class="col-md-6 col-lg-4">
                  <ejs-datepicker #RentalDate format='MM/dd/yyyy' [allowEdit]=false formControlName="RentalDate"
                    (renderDayCell)="onRenderDayCell($event)" class="form-control p-0"
                    style="width: 97.5%;"></ejs-datepicker>
                </div>
              </div>
            </div>
            <div class="row g-3">

              <!-- Generate Report -->
              <div class="col-md-6 col-lg-4 mt-4">
                <div class="card p-3 h-100">
                  <h6 class="fw-bold mb-3">Generate Report</h6>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="reportType" id="boothWise" value="1"
                      formControlName="ReportType">
                    <label class="form-check-label" for="boothWise">{{'Booth-wise' | wordReplace}}</label>
                  </div>
                  <div class="row">
                    <div class="col-6 text-start">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="openBooths" value="1"
                          formControlName="Openbooths">
                        <label class="form-check-label" for="openBooths">{{'Open Booths' | wordReplace}}</label>
                      </div>
                    </div>
                    <div class="col-6 text-start">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="reportType" id="categoryWise" value="2"
                          formControlName="ReportType">
                        <label class="form-check-label" for="categoryWise">Category-cum-Product wise</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Display -->
              <div class="col-md-6 col-lg-4 mt-4">
                <div class="card p-3 h-100">
                  <h6 class="fw-bold mb-3">Display</h6>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="displayType" id="allVendors"
                      formControlName="DisplayVendorid" value="0">
                    <label class="form-check-label" for="allVendors">{{'All Vendors' | wordReplace}}</label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="displayType" id="requestedVendor"
                      formControlName="DisplayVendorid" value="1">
                    <label class="form-check-label" for="requestedVendor">{{'Requested Vendor' |
                      wordReplace}}</label>
                  </div>
                </div>
              </div>

              <!-- Sort On -->
              <div class="col-md-6 col-lg-4 mt-4">
                <div class="card p-3 h-100">
                  <h6 class="fw-bold mb-3">Sort On</h6>
                  <div class="row">
                    <div class="col-md-12 col-lg-6 text-start">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="sortType" id="boothNumber" value="1"
                          formControlName="OrderBy">
                        <label class="form-check-label" for="boothNumber">{{'Booth Number' | wordReplace}}</label>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-6 text-start">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="sortType" id="vendorId" value="2"
                          formControlName="OrderBy">
                        <label class="form-check-label" for="vendorId">{{'Vendor ID' | wordReplace}}</label>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-6 text-start" *ngIf="!noLayout">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="sortType" id="boothType" value="3"
                          formControlName="OrderBy">
                        <label class="form-check-label" for="boothType">{{'Booth Type' | wordReplace}}</label>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-6 text-start">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="sortType" id="vendorName" value="4"
                          formControlName="OrderBy">
                        <label class="form-check-label" for="vendorName">{{ 'Vendor Name' | wordReplace
                          }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card p-3 mt-2">
              <h6 class="fw-bold mb-3">Exclude</h6>

              <div class="d-flex flex-wrap gap-4">
                <div class="form-check" *ngIf="!noLayout">
                  <input class="form-check-input" type="checkbox" id="spaceType" value="1"
                    formControlName="ExcludeBtype">
                  <label class="form-check-label" for="spaceType">{{'Booth Type' | wordReplace}}</label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="partName" value="1"
                    formControlName="ExcludePname">
                  <label class="form-check-label" for="partName">Part Name</label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="boothDesc" value="1"
                    formControlName="ExcludeDesc">
                  <label class="form-check-label" for="boothDesc">{{'Booth Description' | wordReplace}}</label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="rentalEnd" value="1"
                    formControlName="ExcludeEndPeriod">
                  <label class="form-check-label" for="rentalEnd">Rental End Period</label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="balanceDue" value="1"
                    formControlName="ExcludeBDue">
                  <label class="form-check-label" for="balanceDue">Balance Due</label>
                </div>
              </div>
            </div>
            <div class="card p-3 mt-2">
              <h6 class="fw-bold mb-3">Select</h6>

              <div class="d-flex flex-wrap gap-4">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="All" value="1" formControlName="DealerSelect"
                    (change)="resetRevenueCategory()">
                  <label class="form-check-label" for="All">All</label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="radio" id="Range" value="2" formControlName="DealerSelect"
                    (change)="resetRevenueCategory()">
                  <label class="form-check-label" for="Range">Range</label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="radio" id="rdRequestedParts" value="3"
                    formControlName="DealerSelect" (change)="resetRevenueCategory()">
                  <label class="form-check-label" for="rdRequestedParts">Requested Parts</label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="radio" id="rdCategory" value="4" formControlName="DealerSelect">
                  <label class="form-check-label" for="rdCategory">Requested Revenue Category</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-4 text-start mt-2">
                  <label>From</label>
                  <input type="text" formControlName="BoothFrom" class="form-control" style="width: 97.5%;">
                </div>
                <div class="col-md-6 col-lg-4 text-start mt-2">
                  <label>To</label>
                  <input type="text" formControlName="BoothTo" class="form-control" style="width: 97.5%;">
                </div>
                <div class="col-md-6 col-lg-4 text-start mt-2">
                  <label>Revenue Category</label>
                  <select class="form-select" formControlName="revenueCategory">
                    <option *ngFor="let item of revenueCategoriesList" [value]="item.RevSeqCategoryId">
                      {{item.RevTxtCode}}</option>
                  </select>
                </div>
              </div>
              <div class="card shadow-sm mt-2 p-3" *ngIf="mrktReportForm.controls['DealerSelect'].value === '3'">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-2">
                  <div class="form-check">
                    <div class="row">
                      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                        <label class="FormCheckHeading mb-0">Parts</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-2">
                        <ejs-grid #partGrid [dataSource]='parts' class="Table_Height_store table-striped table-ipad"
                          height='140' [allowFiltering]='false' allowSorting='false'
                          (dataBound)='partsdataBound($event)' allowSelection="false"
                          selectionSettings="{checkboxMode : 'ResetOnRowClick'}">
                          <e-columns>
                            <e-column type="checkbox" headerText='' textAlign='left' width=30>
                              <ng-template #headerTemplate>
                              </ng-template>
                            </e-column>
                            <e-column field='PartDescription' headerText='Part' textAlign='left' width=120>
                            </e-column>
                          </e-columns>
                        </ejs-grid>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-3 align-items-center" *ngIf="mrktReportForm.controls['DisplayVendorid'].value === '1'">
                <div class="col-auto">
                  <label>{{'Vendor Id' | wordReplace}}</label>
                </div>
                <div class="col col-lg-2">
                  <input type="text" class="form-control" id="dealerId" formControlName="marketVendorId"
                    (blur)="getVendorById()" />
                </div>
                <div class="col col-lg-3">
                  <input type="text" class="form-control" formControlName="vendorName" disabled />
                </div>
                <div class="col-auto">
                  <button type="button" class="btn btn-sm btn-dark" (click)="OpenVendorSearch(vendorSearchModal)">
                    <img src="./assets/images/search.svg" class="img-fluid" />
                  </button>
                </div>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.FinancialAudit" class="d-block w-100">
            <div class="card shadow-sm">
              <div class="card-body p-2">
                <h6 class="fw-semibold mb-0">Select</h6>
                <div class="row align-items-center">
                  <div class="col-md-6 d-flex align-items-center">
                    <div class="d-flex gap-3 align-items-center">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" value="1" name="selectOpt"
                          formControlName="ReportType" id="optTransaction">
                        <label class="form-check-label" for="optTransaction">Transaction Date</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" value="2" formControlName="ReportType"
                          name="selectOpt" id="optRental">
                        <label class="form-check-label" for="optRental">Rental Period</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" value="3" formControlName="ReportType"
                          name="selectOpt" id="optReceipt">
                        <label class="form-check-label" for="optReceipt">Receipt Range</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6"
                    *ngIf='mrktReportForm.controls["ReportType"].value == "1" || mrktReportForm.controls["ReportType"].value == "2"'>
                    <div class="row g-2 align-items-center">
                      <div class="col-auto">
                        <label class="form-label mb-0">From</label>
                        <ejs-datepicker #fromDate format='MM/dd/yyyy' [allowEdit]=false formControlName="FromDate"
                          class="form-control p-0" style="width: 97.5%;"></ejs-datepicker>
                      </div>
                      <div class="col-auto">
                        <label class="form-label mb-0">To</label>
                        <ejs-datepicker #fromDate format='MM/dd/yyyy' [allowEdit]=false formControlName="ToDate"
                          class="form-control p-0" style="width: 97.5%;"
                          min="{{ this.mrktReportForm.controls['FromDate'].value }}"></ejs-datepicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6" *ngIf='mrktReportForm.controls["ReportType"].value == "3"'>
                    <div class="row g-2 align-items-center">
                      <div class="col-auto">
                        <label class="form-label mb-0">From</label>
                        <input type="text" formControlName="ReceiptFrom" class="form-control" style="width: 97.5%;">
                      </div>
                      <div class="col-auto">
                        <label class="form-label mb-0">To</label>
                        <input type="text" formControlName="ReceiptTo" class="form-control" style="width: 97.5%;">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-4">
              <!-- Display -->
              <div class="col-md-6 col-lg-4 mt-4 pt-2">
                <div class="card shadow-sm h-100">
                  <div class="card-body">
                    <h6 class="mb-3">Display</h6>

                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" id="dispAll" name="display"
                        formControlName="DisplayVendorid" value="0">
                      <label class="form-check-label" for="dispAll">
                        {{'All Vendors' | wordReplace}}
                      </label>
                    </div>

                    <div class="form-check">
                      <input class="form-check-input" type="radio" id="dispReq" name="display"
                        formControlName="DisplayVendorid" value="1">
                      <label class="form-check-label" for="dispReq">
                        {{'Requested Vendor' | wordReplace}}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Exclude -->
              <div class="col-md-6 col-lg-4 mt-4 pt-2">
                <div class="card shadow-sm h-100">
                  <div class="card-body">
                    <h6 class="mb-3">Include</h6>

                    <div class="form-check mb-2">
                      <input class="form-check-input" type="checkbox" id="exUnit" value="1"
                        formControlName="ExcludeUnit">
                      <label class="form-check-label" for="exUnit">
                        Unit Price
                      </label>
                    </div>

                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="exQty" value="1" formControlName="ExcludeQty">
                      <label class="form-check-label" for="exQty">
                        Quantity
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Order By -->
              <div class="col-md-6 col-lg-4 mt-4 pt-2">
                <div class="card shadow-sm h-100">
                  <div class="card-body">
                    <h6 class="mb-3">Order By</h6>

                    <div class="row">
                      <div class="col-md-12 col-lg-6 text-start">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="radio" id="orderRef" name="orderBy" value="1"
                            formControlName="OrderBy">
                          <label class="form-check-label" for="orderRef">
                            Reference
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12 col-lg-6 text-start">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="radio" id="orderOther" name="orderBy" value="2"
                            formControlName="OrderBy">
                          <label class="form-check-label" for="orderOther">
                            Other Items &amp; Reference
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" id="orderReceipt" name="orderBy" value="3"
                        formControlName="OrderBy">
                      <label class="form-check-label" for="orderReceipt">
                        Receipt ID
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3 align-items-center" *ngIf="mrktReportForm.controls['DisplayVendorid'].value === '1'">
              <div class="col-auto">
                <label> {{'Vendor ID' | wordReplace}}</label>
              </div>
              <div class="col col-lg-2">
                <input type="text" class="form-control" id="dealerId" formControlName="marketVendorId"
                  (blur)="getVendorById()" />
              </div>
              <div class="col col-lg-3">
                <input type="text" class="form-control" formControlName="vendorName" disabled />
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-dark" (click)="OpenVendorSearch(vendorSearchModal)">
                  <img src="./assets/images/search.svg" class="img-fluid" />
                </button>
              </div>
            </div>
            <div class="my-3">
            </div>
            <div class="row mb-2">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <!-- Left Side: Label -->
                <label class="otherItemHeading mb-0">Other Items</label>

                <!-- Right Side: Select All & Deselect All Checkboxes -->
                <div class="d-flex align-items-center gap-4">
                  <!-- Select All -->
                  <div class="form-check mb-0">
                    <input type="checkbox" #FAselectbutton class="checkBoxClass"
                      (click)="OtherChargeSelection(FAselectbutton,FAclearselectbutton)">
                    <label class="form-check-label ms-2" for="rdSelectAll">
                      Select All
                    </label>
                  </div>

                  <!-- Deselect All -->
                  <div class="form-check mb-0">
                    <input type="checkbox" #FAclearselectbutton class="checkBoxClass"
                      (click)="OtherChargeClearAllSelection(FAclearselectbutton,FAselectbutton)">
                    <label class="form-check-label ms-2" for="rdDeselectAll">
                      Deselect All
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card shadow-sm mt-2 p-3">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-1 mb-1">
                <ejs-grid #otherGrid [dataSource]='OtherTypeLists' class="Table_Height_store table-striped table-ipad"
                  height='140' [allowFiltering]='true' allowSorting='false' (created)="FAOthercreated($event)"
                  (dataBound)='otheritemdataBound($event)' allowSelection="false"
                  selectionSettings="{checkboxMode : 'ResetOnRowClick'}" (rowSelected)="onOtherGridRowChange()"
                  (rowDeselected)="onOtherGridRowChange()">
                  <e-columns>
                    <e-column type="checkbox" headerText='' textAlign='center' width=10>
                      <ng-template #headerTemplate>
                      </ng-template>
                    </e-column>
                    <e-column field='Description' headerText='Items' textAlign='left' width=120>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.DealerSecDepositLeaseExpiry" class="d-block w-100">
            <div class="card p-2">
              <div class="mb-1">
                <h6 class="form-label fw-bold">Report Type</h6>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-3 text-start">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" formControlName="ReportType" value="1"
                      name="reportType" id="summaryReport">
                    <label class="form-check-label" for="summaryReport">
                      Summary
                    </label>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3 text-start">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" formControlName="ReportType" value="2" type="radio"
                      name="reportType" id="detailReport">
                    <label class="form-check-label" for="detailReport">
                      Detail
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card p-2 mt-2">
              <div class="mb-1">
                <h6 class="form-label fw-bold">Lease Expire for</h6>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-3 text-start">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" formControlName="LeaseExpiry" value="0" type="radio"
                      id="allVendors">
                    <label class="form-check-label" for="allVendors">
                      {{'All Vendors' | wordReplace}}
                    </label>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3 text-start">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" formControlName="LeaseExpiry" value="1"
                      id="selectedDateRange">
                    <label class="form-check-label" for="selectedDateRange">
                      Selected Date Range
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-7 mt-2">
                <div class="card p-2 h-100">
                  <h6 class="card-title fw-semibold">Select Date</h6>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label for="fromDate" class="form-label">From</label>
                      <ejs-datepicker #fromDate format='MM/dd/yyyy' [allowEdit]=false formControlName="FromDate"
                        class="form-control p-0" style="width: 97.5%;"></ejs-datepicker>
                    </div>
                    <div class="col-md-6">
                      <label for="toDate" class="form-label">To</label>
                      <ejs-datepicker #fromDate format='MM/dd/yyyy' [allowEdit]=false formControlName="ToDate"
                        class="form-control p-0" style="width: 97.5%;"
                        min="{{ this.mrktReportForm.controls['FromDate'].value }}"></ejs-datepicker>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-5 mt-2">
                <div class="card p-2 h-100">
                  <h6 class="card-title fw-semibold">Order By</h6>
                  <div class="row mt-2">
                    <div class="col-md-12 col-lg-6">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" formControlName="OrderBy" value="1"
                          id="vendorNameRadio">
                        <label class="form-check-label" for="vendorNameRadio">
                          {{ 'Vendor Name' | wordReplace }}
                        </label>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" formControlName="OrderBy" value="2"
                          id="vendorIdRadio">
                        <label class="form-check-label" for="vendorIdRadio">
                          {{'Vendor ID' | wordReplace}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>

          <span *ngSwitchCase="ERentalReports.VendorWithAutoDeductRent" class="d-block w-100">
            <div class="card shadow-sm p-2">
              <h6 class="mb-3 fw-semibold">Display</h6>

              <div class="d-flex flex-wrap gap-4">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="vendorFilter" id="allVendors" value="1"
                    formControlName="VendorFilter" checked>
                  <label class="form-check-label" for="allVendors">
                    {{'All Vendors' | wordReplace}}
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="vendorFilter" id="requestedVendor" value="2"
                    formControlName="VendorFilter">
                  <label class="form-check-label" for="requestedVendor">
                    {{'Requested Vendor' | wordReplace}}
                  </label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="radio" name="vendorFilter" id="activeVendors" value="3"
                    formControlName="VendorFilter">
                  <label class="form-check-label" for="activeVendors">
                    {{'Active Vendors' | wordReplace}}
                  </label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="radio" name="vendorFilter" id="inactiveVendors" value="4"
                    formControlName="VendorFilter">
                  <label class="form-check-label" for="inactiveVendors">
                    {{'Inactive Vendors' | wordReplace}}
                  </label>
                </div>
              </div>
            </div>
            <div class="row g-3">
              <div class="col-12 col-md-6 mt-4">
                <div class="card p-2 h-100">
                  <h6 class="fw-semibold">Order By</h6>
                  <div class="d-flex gap-4">
                  <div class="form-check mb-2 small-label">
                    <input class="form-check-input" type="radio" name="orderBy" id="orderByName" value="1"
                      formControlName="OrderBy" checked>
                    <label class="form-check-label" for="orderByName">{{'Vendor Name' |
                      wordReplace}}</label>
                  </div>
                  <div class="form-check small-label">
                    <input class="form-check-input" type="radio" name="orderBy" id="orderById" value="2"
                      formControlName="OrderBy">
                    <label class="form-check-label" for="orderById">{{'Vendor ID' | wordReplace}}</label>
                  </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 mt-4">
                <div class="card p-2 h-100">
                  <h6 class="fw-semibold">Auto Deduct Rent</h6>

                  <div class="d-flex align-items-start gap-3">
                    <div class="form-check small-label">
                      <input class="form-check-input" type="radio" name="autoDeduct" id="autoYes" value="1"
                        formControlName="AutoDeductOption" checked>
                      <label class="form-check-label" for="autoYes">Yes</label>
                    </div>

                    <div class="form-check small-label">
                      <input class="form-check-input" type="radio" name="autoDeduct" id="autoNo" value="2"
                        formControlName="AutoDeductOption">
                      <label class="form-check-label" for="autoNo">No</label>
                    </div>

                    <div class="form-check small-label">
                      <input class="form-check-input" type="radio" name="autoDeduct" id="autoBoth" value="3"
                        formControlName="AutoDeductOption">
                      <label class="form-check-label" for="autoBoth">Both</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2 align-items-center" *ngIf="mrktReportForm.controls['VendorFilter'].value === '2'">
              <div class="col-auto">
                <label>{{'Vendor ID' | wordReplace}}</label>
              </div>
              <div class="col col-lg-2">
                <input type="text" class="form-control" formControlName="marketVendorId" (blur)="getVendorById()" />
              </div>
              <div class="col col-lg-3">
                <input type="text" class="form-control" formControlName="vendorName" readonly />
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-dark" (click)="OpenVendorSearch(vendorSearchModal)">
                  <img src="./assets/images/search.svg" class="img-fluid" />
                </button>
              </div>
            </div>
          </span>

          <span *ngSwitchCase="ERentalReports.VendorLeaseExpiry" class="d-block w-100">
            <div class="card p-2">
              <h6 class="fw-semibold">Lease Expiry</h6>

              <div class="row g-3 align-items-center">
                <div class="col-12 col-md-4">
                  <div class="form-check small-label mb-2">
                    <input class="form-check-input" type="radio" name="leaseExpiry" id="allLease" value="all" checked>
                    <label class="form-check-label" for="allLease">
                      All Lease Expiry
                    </label>
                  </div>

                  <div class="form-check small-label">
                    <input class="form-check-input" type="radio" name="leaseExpiry" id="rangeLease" value="range">
                    <label class="form-check-label" for="rangeLease">
                      Lease Expiry for Selected Date Range
                    </label>
                  </div>
                </div>
                <div class="col-6 col-md-4">
                  <label for="fromDate" class="form-label mb-1">From</label>
                  <div class="input-group">
                    <ejs-datepicker class="form-control p-0"></ejs-datepicker>
                  </div>
                </div>

                <div class="col-6 col-md-4">
                  <label for="toDate" class="form-label mb-1">To</label>
                  <div class="input-group">
                    <ejs-datepicker class="form-control p-0"></ejs-datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <div class="card p-2 h-100 mt-2">
                  <h6 class="fw-semibold">{{'Vendor' | wordReplace}}</h6>

                  <div class="d-flex gap-4 align-items-start">
                    <div class="form-check form-check-inline small-label">
                      <input class="form-check-input" type="radio" name="vendorStatus" id="vendorAll" value="all"
                        checked>
                      <label class="form-check-label" for="vendorAll">All</label>
                    </div>

                    <div class="form-check form-check-inline small-label">
                      <input class="form-check-input" type="radio" name="vendorStatus" id="vendorActive" value="active">
                      <label class="form-check-label" for="vendorActive">Active</label>
                    </div>

                    <div class="form-check form-check-inline small-label">
                      <input class="form-check-input" type="radio" name="vendorStatus" id="vendorInactive"
                        value="inactive">
                      <label class="form-check-label" for="vendorInactive">Inactive</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="card p-2 h-100 mt-2">
                  <h6 class="fw-semibold">Order By</h6>

                  <div class="row">
                    <div class="col-6">
                      <div class="form-check small-label">
                        <input class="form-check-input" type="radio" name="orderBy" id="orderById" value="id" checked>
                        <label class="form-check-label" for="orderById">{{'Vendor ID' | wordReplace}}</label>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-check small-label">
                        <input class="form-check-input" type="radio" name="orderBy" id="orderByName" value="name">
                        <label class="form-check-label" for="orderByName">Vendor Name</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>

          <span *ngSwitchCase="ERentalReports.BoothsDroppedbyDealer" class="d-block w-100">
            <div class="card p-3">
              <div class="row">
                <div class="col-6 col-lg-4 text-start mt-2">
                  <div class="form-check d-flex align-items-center me-3">
                    <input class="form-check-input" type="radio" name="droppedOption" id="droppedOn" value="1"
                      formControlName="ReportType">
                    <label class="form-check-label radio-label mb-0 ms-1 mt-1" for="droppedOn">Dropped On</label>
                  </div>
                </div>
                <div class="col-6 col-lg-4 text-start mt-2">
                  <div class="form-check d-flex align-items-center">
                    <input class="form-check-input" type="radio" name="droppedOption" id="droppedFor" value="2"
                      formControlName="ReportType">
                    <label class="form-check-label radio-label mb-0 ms-1 mt-1" for="droppedFor">Dropped For</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6 text-start mt-2">
                <div class="card p-3">
                  <h6>Selected Date</h6>
                  <div class="row">
                    <div class="col-md-12 col-lg-6 text-start mt-2">
                      <label>From</label>
                      <ejs-datepicker #fromDate format='MM/dd/yyyy' [allowEdit]=false formControlName="FromDate"
                        class="form-control p-0" style="width: 97.5%;"></ejs-datepicker>
                    </div>
                    <div class="col-md-12 col-lg-6 text-start mt-2">
                      <label>To</label>
                      <ejs-datepicker #toDate format='MM/dd/yyyy' [allowEdit]=false formControlName="ToDate"
                        class="form-control p-0" style="width: 97.5%;"
                        min="{{ this.mrktReportForm.controls['FromDate'].value }}"></ejs-datepicker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6 text-start mt-2">
                <div class="card p-3">
                  <h6>Selected Month</h6>
                  <div class="row">
                    <div class="col-12 text-start mt-2">
                      <label for="monthYearSelect">Month</label>
                      <select class="form-select" id="monthYearSelect" formControlName="selectedMonthYear">
                        <option *ngFor="let option of monthYearOptions" [value]="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-start mt-2">
                <div class="card p-3">
                  <h6>Order By</h6>
                  <div class="row">
                    <div class="col-6 col-lg-4 mt-2">
                      <div class="form-check d-flex align-items-center">
                        <input class="form-check-input" type="radio" name="orderby" id="rdVenID" value="1"
                          formControlName="OrderBy">
                        <label class="form-check-label radio-label mb-0 ms-1 mt-1" for="rdVenID">{{'Vendor' |
                          wordReplace}} ID</label>
                      </div>
                    </div>
                    <div class="col-6 col-lg-4 mt-2">
                      <div class="form-check d-flex align-items-center">
                        <input class="form-check-input" type="radio" name="orderby" id="rdVenName" value="2"
                          formControlName="OrderBy">
                        <label class="form-check-label radio-label mb-0 ms-1 mt-1" for="rdVenName">{{'Vendor' |
                          wordReplace}} Name</label>
                      </div>
                    </div>
                    <div class="col-6 col-lg-4 mt-2">
                      <div class="form-check d-flex align-items-center">
                        <input class="form-check-input" type="radio" name="orderby" id="rdBoothNum" value="3"
                          formControlName="OrderBy">
                        <label class="form-check-label radio-label mb-0 ms-1 mt-1" for="rdBoothNum">Booth#</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.TransactionJournal" class="d-block w-100">
            <div class="border rounded p-2 bg-white">
              <h6 class="col-auto fw-semibold">Select</h6>
              <div class="row align-items-end g-2">
                <div class="col-auto">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="selectType" id="rentalPeriod"
                      formControlName="PeriodOrRange" value="0" />
                    <label class="form-check-label" for="rentalPeriod">
                      Rental Period
                    </label>
                  </div>

                  <div class="form-check form-check-inline ms-3">
                    <input class="form-check-input" type="radio" name="selectType" id="receiptRange"
                      formControlName="PeriodOrRange" value="1" />
                    <label class="form-check-label" for="receiptRange">
                      Receipt Range
                    </label>
                  </div>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left mt-2"
                  *ngIf="mrktReportForm.controls['PeriodOrRange'].value == 0">

                  <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                      <label>From</label>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10">
                      <ejs-datepicker #fromDate format='MM/dd/yyyy' [allowEdit]=false formControlName="FromDate"
                        class="form-control p-0" style="width: 97.5%;"></ejs-datepicker>
                    </div>
                  </div>

                  <div class="row mt-2 mb-2">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                      <label>To</label>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10">
                      <ejs-datepicker #fromDate format='MM/dd/yyyy' [allowEdit]=false formControlName="ToDate"
                        class="form-control p-0" style="width: 97.5%;"
                        min="{{ this.mrktReportForm.controls['FromDate'].value }}"></ejs-datepicker>
                    </div>
                  </div>

                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left mt-2"
                  *ngIf="mrktReportForm.controls['PeriodOrRange'].value == 1">
                  <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                      <label>From</label>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10">
                      <input type="text" class="form-control p-0" formControlName="TJReceiptFrom" style="width: 97.5%;">
                    </div>
                  </div>
                  <div class="row mt-2 mb-2">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                      <label>To</label>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10">
                      <input type="text" class="form-control p-0" formControlName="TJReceiptTo" style="width: 97.5%;">
                    </div>
                  </div>
                </div>

                <div class="row mb-2" *ngIf="mrktReportForm.controls['PeriodOrRange'].value == 1">
                  <div class="row mb-2">
                    <div class="col-12 d-flex justify-content-between align-items-center">

                      <div class="d-flex align-items-center gap-4">
                        <!-- Select All -->
                        <div class="form-check mb-0">
                          <input type="checkbox" #Terselectbutton class="checkBoxClass"
                            (click)="TerminalSelection(Terselectbutton,Terclearselectbutton)">
                          <label class="form-check-label ms-2" for="rdSelectAll">
                            Select All
                          </label>
                        </div>

                        <!-- Deselect All -->
                        <div class="form-check mb-0">
                          <input type="checkbox" #Terclearselectbutton class="checkBoxClass"
                            (click)="TerminalClearAllSelection(Terclearselectbutton,Terselectbutton)">
                          <label class="form-check-label ms-2" for="rdDeselectAll">
                            Deselect All
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card shadow-sm mt-2 p-3">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-1 mb-1">
                      <ejs-grid #terminalGrid [dataSource]='terminalsLists'
                        class="Table_Height_store table-striped table-ipad" height='140' [allowFiltering]='true'
                        allowSorting='false' (dataBound)='terminaldataBound($event)' allowSelection="false"
                        selectionSettings="{checkboxMode : 'ResetOnRowClick'}" (rowSelected)="onTerminalGridRowChange()"
                        (rowDeselected)="onTerminalGridRowChange()">
                        <e-columns>
                          <e-column type="checkbox" headerText='' textAlign='center' width=10>
                            <ng-template #headerTemplate>
                            </ng-template>
                          </e-column>
                          <e-column field='Name' headerText='Terminals' textAlign='left' width=120>
                          </e-column>
                        </e-columns>
                      </ejs-grid>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-4 mt-4">
                <div class="border rounded p-3 h-100 bg-white">
                  <h6 class="fw-semibold mb-2">Display</h6>
                  <div class="d-flex gap-4">
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="radio" name="reportType" id="summaryReport"
                      formControlName="ReportType" value="1">
                    <label class="form-check-label" for="summaryReport">
                      Summary Report
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="reportType" id="detailedReport"
                      formControlName="ReportType" value="2">
                    <label class="form-check-label" for="detailedReport">
                      Detailed Report
                    </label>
                  </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-8 mt-4">
                <div class="border rounded p-3 h-100 bg-white">

                  <h6 class="fw-semibold mb-2">Display</h6>

                  <div class="row g-3">
                    <div class="col-12">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="userFilter" id="allUsers"
                          formControlName="allUsers" value="0">
                        <label class="form-check-label" for="allUsers">
                          All
                        </label>
                      </div>
                    </div>
                    <div class="col-12 d-flex align-items-center gap-3">
                      <div class="form-check mb-0">
                        <input class="form-check-input" type="radio" name="userFilter" id="requestedUser"
                          formControlName="allUsers" value="1">
                        <label class="form-check-label" for="requestedUser">
                          Requested User
                        </label>
                      </div>
                      <select id="ddlUserName" class="form-select w-50" formControlName="UserId">
                        <option value=""></option>
                        <ng-container *ngFor="let term of userList">
                          <option *ngIf="!term.UserInactive" [value]="term.UserId">
                            {{ term.UserName }}
                          </option>
                        </ng-container>
                      </select>

                    </div>

                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="revenueBreakup" formControlName="RevenueBreakup"
                      value="1">
                    <label class="form-check-label" for="revenueBreakup">
                      Display Revenue Breakup
                    </label>
                  </div>
                </div>
              </div>


            </div>
            <div class="row">
              <div class="col-md-12 col-lg-4 mt-2">
                <div class="border rounded p-2 h-100">
                  <div class="fw-semibold mb-2">Display</div>
                  <div class="d-flex gap-4">
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="radio" name="vendorDisplay" id="allVendors"
                      formControlName="DisplayVendorid" value="0">
                    <label class="form-check-label" for="allVendors">
                      {{'All Vendors' | wordReplace}}
                    </label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="vendorDisplay" id="requestedVendor"
                      formControlName="DisplayVendorid" value="1">
                    <label class="form-check-label" for="requestedVendor">
                      {{'Requested Vendor' | wordReplace}}
                    </label>
                  </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-8 mt-2">
                <div class="border rounded p-3 h-100 bg-white">
                  <div class="fw-semibold mb-3">Order By</div>
                  <div class="d-flex flex-wrap gap-3">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="orderBy" id="vendorId"
                        formControlName="OrderBy" value="1">
                      <label class="form-check-label" for="vendorId">{{'Vendor Id' | wordReplace}}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="orderBy" id="vendorName"
                        formControlName="OrderBy" value="2">
                      <label class="form-check-label" for="vendorName">{{'Vendor Name' | wordReplace}}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="orderBy" id="receiptId"
                        formControlName="OrderBy" value="3">
                      <label class="form-check-label" for="receiptId">
                        Receipt ID
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3 align-items-center" *ngIf="mrktReportForm.controls['DisplayVendorid'].value === '1'">
              <div class="col-auto">
                <label>{{'Vendor Id' | wordReplace}}</label>
              </div>
              <div class="col col-lg-2">
                <input type="text" class="form-control" id="dealerId" formControlName="marketVendorId"
                  (blur)="getVendorById()" />
              </div>
              <div class="col col-lg-3">
                <input type="text" class="form-control" formControlName="vendorName" disabled />
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-dark" (click)="OpenVendorSearch(vendorSearchModal)">
                  <img src="./assets/images/search.svg" class="img-fluid" />
                </button>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.YTDPayments" class="d-block w-100">
            <div class="row">
              <div class="col-md-6 col-lg-4 text-start mt-2">
                <label>YTD Payments for the Fiscal Year</label>
                <select class="form-select" id="fiscalYear" formControlName="FiscalYear">
                  <option [value]="null" disabled>Select</option>
                  @for (fy of fiscalYearList; track fy.id) {
                  <option [value]="fy.id">{{ fy.text}}</option>
                  }
                </select>

              </div>
            </div>
            <div class="row g-3">
              <div class="col-md-12 col-lg-4">
                <div class="card p-2 h-100 mt-2">
                  <div class="fw-semibold mb-2">Display</div>
                  <div class="d-flex gap-4">
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="radio" name="VendorFilter" id="allVendors"
                      formControlName="DisplayVendorid" value="0">
                    <label class="form-check-label" for="allVendors">
                      {{'All Vendors' | wordReplace}}
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="dispReq" name="VendorFilter"
                      formControlName="DisplayVendorid" value="1">
                    <label class="form-check-label" for="requestedVendor">
                      {{'Requested Vendor' | wordReplace}}
                    </label>
                  </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-8">
                <div class="card p-2 h-100 mt-2">
                  <div class="fw-semibold mb-2">Order By</div>

                  <div class="d-flex flex-wrap gap-4 mt-2">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="orderBy" id="vendorId"
                        formControlName="OrderBy" value="1">
                      <label class="form-check-label" for="vendorId">
                        {{ 'Vendor ID' | wordReplace}}
                      </label>
                    </div>

                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="orderBy" id="vendorName"
                        formControlName="OrderBy" value="2">
                      <label class="form-check-label" for="vendorName">
                        {{ 'Vendor Name' | wordReplace}}
                      </label>
                    </div>

                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="orderBy" id="totalAmount"
                        formControlName="OrderBy" value="3">
                      <label class="form-check-label" for="totalAmount">
                        Total Amount Paid
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-check mt-3">
              <input class="form-check-input" type="checkbox" id="chkPaymentReport" formControlName="IncludeSales">
              <label class="form-check-label" for="chkPaymentReport">YTD Sales and Payment Report</label>
            </div>
            <div class="row mt-2 align-items-center">
              <div class="col-auto">
                <label>{{'Vendor Id' | wordReplace}}</label>
              </div>
              <div class="col col-lg-2">
                <input type="text" class="form-control" id="dealerId" formControlName="marketVendorId"
                  (blur)="getVendorById()" />
              </div>
              <div class="col col-lg-3">
                <input type="text" class="form-control" formControlName="vendorName" />
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-dark" (click)="OpenVendorSearch(vendorSearchModal)"
                  [disabled]="mrktReportForm.get('DisplayVendorid')?.value !== '1'">
                  <img src="./assets/images/search.svg" class="img-fluid" />
                </button>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.VendorListing" class="d-block w-100">
            <div class="card">
              <div class="card-body">
                <label class="form-label fw-semibold mb-3">Display</label>
                <div class="d-flex flex-wrap gap-4">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="vendorStatus" id="allVendors" value="1"
                      formControlName="VendorFilter">
                    <label class="form-check-label" for="allVendors">
                      All Vendors
                    </label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="vendorStatus" id="requestedVendor" value="2"
                      formControlName="VendorFilter">
                    <label class="form-check-label" for="requestedVendor">
                      Requested Vendor
                    </label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="vendorStatus" id="activeVendors" value="3"
                      formControlName="VendorFilter">
                    <label class="form-check-label" for="activeVendors">
                      Active Vendors Only
                    </label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="vendorStatus" id="inactiveVendors" value="4"
                      formControlName="VendorFilter">
                    <label class="form-check-label" for="inactiveVendors">
                      Inactive Vendors Only
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-3">

              <div class="col-md-6 mt-4">
                <div class="card h-100">
                  <div class="card-body">
                    <label class="form-label fw-semibold mb-3">Order By</label>
<div class="d-flex gap-4">
  <div class="form-check mb-2">
    <input class="form-check-input" type="radio" name="orderBy" id="vendorName" value="1" formControlName="OrderBy">
    <label class="form-check-label" for="vendorName">
      {{'Vendor Name' | wordReplace}}
    </label>
  </div>

  <div class="form-check">
    <input class="form-check-input" type="radio" name="orderBy" id="vendorId" value="2" formControlName="OrderBy">
    <label class="form-check-label" for="vendorId">
      {{'Vendor Id' | wordReplace}}
    </label>
  </div>
</div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mt-4">
                <div class="card h-100">
                  <div class="card-body">
                    <label class="form-label fw-semibold mb-3">Display</label>

                    <div class="d-flex flex-wrap gap-4">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="displayType" id="summary" value="1"
                          formControlName="ReportType">
                        <label class="form-check-label" for="summary">
                          Summary Report
                        </label>
                      </div>

                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="displayType" id="detailed" value="2"
                          formControlName="ReportType">
                        <label class="form-check-label" for="detailed">
                          Detailed Report
                        </label>
                      </div>

                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="displayType" id="address" value="3"
                          formControlName="ReportType">
                        <label class="form-check-label" for="address">
                          {{'Vendor Address' | wordReplace}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3 align-items-center">
              <div class="col-auto">
                <label>{{'Vendor Id' | wordReplace}}</label>
              </div>
              <div class="col col-lg-2">
                <input type="text" class="form-control" formControlName="marketVendorId" (blur)="getVendorById()" />
              </div>
              <div class="col col-lg-3">
                <input type="text" class="form-control" formControlName="vendorName" readonly />
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-dark"
                  [disabled]="mrktReportForm.controls['VendorFilter'].value !== '2'"
                  (click)="OpenVendorSearch(vendorSearchModal)">
                  <img src="./assets/images/search.svg" class="img-fluid" />
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-auto mt-3">
                <span>Include</span>
              </div>
              <div class="col-auto mt-3">
                <div class="form-check">
                  <input type="checkbox" id="chkBookings" class="form-check-input" value="1" formControlName="Bookings">
                  <label for="chkBookings" class="form-check-label">Bookings</label>
                </div>
              </div>
              <div class="col-auto mt-3">
                <div class="form-check">
                  <input type="checkbox" id="chkReservations" class="form-check-input" value="1"
                    formControlName="Reservations">
                  <label for="chkReservations" class="form-check-label">Reservations</label>
                </div>
              </div>
              <div class="col-auto mt-3">
                <div class="form-check">
                  <input type="checkbox" id="chkVendorNotes" class="form-check-input" value="1"
                    formControlName="VendorNotes">
                  <label for="chkVendorNotes" class="form-check-label">Vendor Notes</label>
                </div>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.DesignVendorReport" class="d-block w-100">
            <div class="row">
              <div class="col-md-12 col-lg-8 col-xl-9 text-start mt-2">
                <div class="card h-100">
                  <div class="card-body">
                    <h6>Select</h6>
                    <div class="row">
                      <div class="col-6 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdAllActiveVendors" class="form-check-input" value="1" formControlName="VDRReportType">
                          <label for="rdAllActiveVendors" class="form-check-label">All Active Vendors</label>
                        </div>
                      </div>
                      <div class="col-6 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdDrivingLicenseExpiryDate" class="form-check-input" value="2" formControlName="VDRReportType">
                          <label for="rdDrivingLicenseExpiryDate" class="form-check-label">By Driving License Expiry
                            Date</label>
                        </div>
                      </div>
                      <div class="col-6 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdAllInactiveVendors" class="form-check-input" value="3" formControlName="VDRReportType">
                          <label for="rdAllInactiveVendors" class="form-check-label">All Inactive Vendors</label>
                        </div>
                      </div>
                      <div class="col-6 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdVendorNoSale" class="form-check-input" value="4" formControlName="VDRReportType">
                          <label for="rdVendorNoSale" class="form-check-label">Vendor with No Sale</label>
                        </div>
                      </div>
                      <div class="col-6 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdOutstandingBalance" class="form-check-input" value="5" formControlName="VDRReportType">
                          <label for="rdOutstandingBalance" class="form-check-label">Vendors with Outstanding
                            Balance</label>
                        </div>
                      </div>
                      <div class="col-6 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdWebInquiryEnabledVendors" class="form-check-input" value="6" formControlName="VDRReportType">
                          <label for="rdWebInquiryEnabledVendors" class="form-check-label">Currently Web Inquiry Enabled
                            Vendors</label>
                        </div>
                      </div>
                      <div class="col-6 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdCurrentBookings" class="form-check-input" value="7" formControlName="VDRReportType">
                          <label for="rdCurrentBookings" class="form-check-label">Vendors with Current Bookings</label>
                        </div>
                      </div>
                      <div class="col-6 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdWebInquiryNotEnabled" class="form-check-input" value="8" formControlName="VDRReportType">
                          <label for="rdWebInquiryNotEnabled" class="form-check-label">Currently Web Inquiry Not Enabled
                            Vendors</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-4 col-xl-3 text-start mt-2">
                <div class="card h-100">
                  <div class="card-body">
                    <span>From</span>
                    <ejs-datepicker #fromDate format='MM/dd/yyyy' [allowEdit]=false formControlName="FromDate"
                          class="form-control p-0" style="width: 97.5%;"></ejs-datepicker>
                    <br />
                    <span>To</span>
                    <ejs-datepicker #toDate format='MM/dd/yyyy' [allowEdit]=false formControlName="ToDate"
                          class="form-control p-0" style="width: 97.5%;"
                          ></ejs-datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-start mt-2">
                <div class="card">
                  <div class="card-body">
                    <h6>Sort By</h6>
                    <div class="row">
                      <div class="col-6 col-lg-3 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdVenID" class="form-check-input" value="1" formControlName="OrderBy">
                          <label class="form-check-label" for="rdVenID">{{'Vendor ID' | wordReplace}}</label>
                        </div>
                      </div>
                      <div class="col-6 col-lg-3 text-start mt-2">
                        <div class="form-check">
                          <input type="radio" id="rdVenName" class="form-check-input" value="2" formControlName="OrderBy">
                          <label for="rdVenName" class="form-check-label">{{'Vendor Name' | wordReplace}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mt-2">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-5 col-lg-4 text-start mt-2">
                    <ejs-grid  #gridAvailableColumns1 class="Table_Height_store table-striped table-ipad" height='250'
                      [allowFiltering]='false' allowSorting='false' allowSelection="true" [dataSource]='vendorColumns1'>
                      <e-columns>
                        <e-column field='VdrTxtVendorColumnDesc' headerText='Available Columns' textAlign='left'
                          width=120>
                        </e-column>
                      </e-columns>
                    </ejs-grid>
                  </div>
                  <div class="col-md-2 col-lg-1 text-center" style="margin-top: 8rem;">
                    <img src="./assets/images/next.svg" class="img-fluid"  (click)="addToActiveGrid()"/>
                    <br/>
                    <img src="./assets/images/previous.svg" class="img-fluid mt-3" (click)="addToAllGrid()"/>
                  </div>
                  <div class="col-md-5 col-lg-4 text-start mt-2">
                    <ejs-grid #gridSelectedColumns1 class="Table_Height_store table-striped table-ipad" height='300'
                      [allowFiltering]='false' allowSorting='false' allowSelection="true"
                      [dataSource]='selectedColumns1'>
                      <e-columns>
                        <e-column field='VdrTxtVendorColumnDesc' headerText='Selected Columns' textAlign='left'
                          width=120></e-column>
                      </e-columns>
                    </ejs-grid>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <span *ngSwitchCase="ERentalReports.RentalRevenueandPayment" class="d-block w-100">
            <div class="row">
              <div class="col-md-12 col-lg-6 text-start mt-2">
                <div class="card p-3">
                  <h6>Selected Month</h6>
                  <div class="row">
                    <div class="col-12 text-start mt-2">
                      <label for="monthYearSelect">Month</label>
                      <select class="form-select" id="monthYearSelect" formControlName="selectedMonthYear">
                        <option *ngFor="let option of monthYearOptions" [value]="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2" >
            <div class="col-md-12 col-lg-4">
                <div class="card p-2 h-100 mt-2">
                  <div class="fw-semibold mb-2">Display</div>
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="radio" name="VendorFilter" id="allVendors"
                      formControlName="DisplayVendorid" value="0">
                    <label class="form-check-label" for="allVendors">
                      {{'All Vendors' | wordReplace}}
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="requestedVendor" name="VendorFilter"
                      formControlName="DisplayVendorid" value="1">
                    <label class="form-check-label" for="requestedVendor">
                      {{'Requested Vendor' | wordReplace}}
                    </label>
                  </div>
                </div>
              </div>
              </div>
              <div class="row mt-3 align-items-center" *ngIf="mrktReportForm.controls['DisplayVendorid'].value === '1'">
              <div class="col-auto">
                <label>{{'Vendor Id' | wordReplace}}</label>
              </div>
              <div class="col col-lg-2">
                <input type="text" class="form-control" formControlName="marketVendorId" (blur)="getVendorById()" />
              </div>
              <div class="col col-lg-3">
                <input type="text" class="form-control" formControlName="vendorName" readonly />
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-dark"
                (click)="OpenVendorSearch(vendorSearchModal)">
                  <img src="./assets/images/search.svg" class="img-fluid" />
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-start mt-2">
                <div class="card p-3">
                  <h6>Order By</h6>
                  <div class="row">
                    <div class="col-md-6 col-lg-4 mt-2">
                      <div class="form-check d-flex align-items-center">
                        <input class="form-check-input" type="radio" name="orderby" id="rdVenID" value="1"
                          formControlName="OrderBy">
                        <label class="form-check-label radio-label mb-0 ms-1 mt-1" for="rdVenID">{{'Vendor' |
                          wordReplace}} ID</label>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mt-2">
                      <div class="form-check d-flex align-items-center">
                        <input class="form-check-input" type="radio" name="orderby" id="rdVenName" value="2"
                          formControlName="OrderBy">
                        <label class="form-check-label radio-label mb-0 ms-1 mt-1" for="rdVenName">{{'Vendor' |
                          wordReplace}} Name</label>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mt-2">
                      <div class="form-check d-flex align-items-center">
                        <input class="form-check-input" type="radio" name="orderby" id="rdBoothNum" value="3"
                          formControlName="OrderBy">
                        <label class="form-check-label radio-label mb-0 ms-1 mt-1" for="rdBoothNum">Booth#</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <div>
    <button type="button" class="btn btnAS me-1" data-dismiss="modal" (click)="onReportView(0)">Show</button>
  </div>
  <button type="button" *ngIf="selectedReportID ===ERentalReports.DesignVendorReport" class="btn btn-primary mr-1"
    data-dismiss="modal" (click)="exportToExcel(false)">Export to Excel</button>
  <button type="button" class="btn btn-orange" data-dismiss="modal" (click)="closeModal()">Cancel</button>
</div>

<ng-template #vendorSearchModal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="vendorSearchLabel">
        {{'Select Vendor' | wordReplace}}
      </h5>
      <button type="button" class="btn-close" (click)="hideVendorSearch()"></button>
    </div>
    <div class="modal-body">
      <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption"
        (vendorSearchRoute)="onVendorSelected($event)">
      </app-vendor-search>
    </div>
  </div>
</ng-template>
